import React from "react";
import components from "gatsby-theme-golden-condor/src/gatsby-plugin-theme-ui/components";
import SandPackEditor from "../../components/SandPackEditor";
export default {
  ...components,
  SandPackEditor,
  // your overrides / additions
};
